var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _rect, _rect2, _rect3, _rect4, _path34;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 206,
    viewBox: "0 0 360 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300 137.5L214 183L59 92.5L140 45L300 137.5Z",
    fill: "#E5F7F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M226 206H112.5H-1V71.5L226 206Z",
    fill: "#00B0A6",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M223.488 132.9C225.658 132.9 227.418 132.188 227.418 131.309C227.418 130.431 225.658 129.719 223.488 129.719C221.317 129.719 219.558 130.431 219.558 131.309C219.558 132.188 221.317 132.9 223.488 132.9Z",
    fill: "#192643"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M229.85 111.004C229.85 116.65 226.17 121.453 223.394 121.453C220.618 121.453 217 117.086 217 111.441C217 105.796 220.618 97 223.394 97C226.17 97 229.85 105.359 229.85 111.004Z",
    fill: "#192643"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M223.488 102.614V131.465",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M219.963 107.885L223.487 112.844",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M226.95 104.143L223.425 109.133",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M226.95 111.129L223.425 116.12",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M219.963 114.436L223.487 119.426",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M222.24 131.153C222.24 131.153 223.675 131.902 224.735 131.153",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M144.488 93.9002C146.658 93.9002 148.418 93.188 148.418 92.3095C148.418 91.4309 146.658 90.7188 144.488 90.7188C142.317 90.7188 140.558 91.4309 140.558 92.3095C140.558 93.188 142.317 93.9002 144.488 93.9002Z",
    fill: "#192643"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M150.85 72.0044C150.85 77.6498 147.17 82.4531 144.394 82.4531C141.618 82.4531 138 78.0865 138 72.4411C138 66.7956 141.618 58 144.394 58C147.17 58 150.85 66.359 150.85 72.0044Z",
    fill: "#192643"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M144.488 63.6143V92.4652",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M140.963 68.8853L144.487 73.8445",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M147.95 65.1426L144.425 70.133",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M147.95 72.1294L144.425 77.1198",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M140.963 75.4355L144.487 80.426",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M143.24 92.1533C143.24 92.1533 144.675 92.9019 145.735 92.1533",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M213.065 119.688C209.314 119.688 206.273 118.458 206.273 116.939C206.273 115.421 209.314 114.19 213.065 114.19C216.815 114.19 219.856 115.421 219.856 116.939C219.856 118.458 216.815 119.688 213.065 119.688Z",
    fill: "#192643"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M215.216 116.674C215.216 116.674 212.737 117.968 210.904 116.674",
    stroke: "#00B0A6",
    strokeWidth: 2.081,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M220.5 136.237V111.119L206 97.7646L191.501 122.882V153L220.5 136.237Z",
    fill: "#00B0A6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M191.499 122.881L205.998 97.763L154.5 68L140 93L191.499 122.881Z",
    fill: "#192643"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M191.505 122.885L140 92.8823V123L191.505 153.003V122.885Z",
    fill: "#018289"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M204.384 126.215V145.565L211.067 141.684V122.334L204.384 126.215Z",
    fill: "#192643"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M179.964 126.208L173.28 122.328V133.916L179.964 137.797V126.208Z",
    fill: "#192643"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M204.384 145.564L211.067 141.684L204.384 137.372V145.564Z",
    fill: "#101627"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M179.964 137.797L173.28 133.917L179.964 129.604V137.797Z",
    fill: "#101627"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M154.964 111.208L148.28 107.328V118.916L154.964 122.797V111.208Z",
    fill: "#192643"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M154.964 122.797L148.28 118.917L154.964 114.604V122.797Z",
    fill: "#101627"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M129.5 36L48.5 83L-0.5 53.5V3H63.5L129.5 36Z",
    fill: "#00B0A6",
    fillOpacity: 0.1
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M304.333 57.3055C304.333 75.231 289.801 89.7638 271.875 89.7638C253.95 89.7638 239.417 75.231 239.417 57.3055C239.417 39.38 253.95 24.8472 271.875 24.8472C289.801 24.8472 304.333 39.38 304.333 57.3055Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M300.917 54.4583C300.917 72.3839 286.384 86.9167 268.458 86.9167C250.533 86.9167 236 72.3839 236 54.4583C236 36.5328 250.533 22 268.458 22C286.384 22 300.917 36.5328 300.917 54.4583Z",
    fill: "#152954"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M178 58L178 83",
    stroke: "#192643",
    strokeWidth: 2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M238 58L177 58",
    stroke: "#192643",
    strokeWidth: 2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M251.492 57.1284V72.1647C251.492 72.6241 251.865 73 252.322 73H268.097V57.1284H251.492ZM263.115 62.1405H258.964C258.507 62.1405 258.134 61.7646 258.134 61.3051C258.134 60.8457 258.507 60.4698 258.964 60.4698H263.115C263.572 60.4698 263.945 60.8457 263.945 61.3051C263.945 61.7646 263.572 62.1405 263.115 62.1405ZM249.317 49.7857C248.96 50.0697 248.893 50.596 249.175 50.9635C249.458 51.3227 249.981 51.3895 250.346 51.1055L251.492 50.2033V55.4577H268.097V35L249.317 49.7857ZM263.115 47.1042H258.964C258.507 47.1042 258.134 46.7283 258.134 46.2688C258.134 45.8094 258.507 45.4335 258.964 45.4335H263.115C263.572 45.4335 263.945 45.8094 263.945 46.2688C263.945 46.7283 263.572 47.1042 263.115 47.1042ZM269.757 57.1284V73H285.532C285.988 73 286.362 72.6241 286.362 72.1647V57.1284H269.757ZM278.89 62.1405H274.739C274.282 62.1405 273.908 61.7646 273.908 61.3051C273.908 60.8457 274.282 60.4698 274.739 60.4698H278.89C279.346 60.4698 279.72 60.8457 279.72 61.3051C279.72 61.7646 279.346 62.1405 278.89 62.1405ZM288.537 49.7857L269.757 35V55.4577H286.362V50.2033L287.508 51.1055C287.665 51.2225 287.84 51.2809 288.022 51.2809C288.271 51.2809 288.512 51.1723 288.678 50.9635C288.96 50.596 288.894 50.0697 288.537 49.7857ZM278.89 47.1042H274.739C274.282 47.1042 273.908 46.7283 273.908 46.2688C273.908 45.8094 274.282 45.4335 274.739 45.4335H278.89C279.346 45.4335 279.72 45.8094 279.72 46.2688C279.72 46.7283 279.346 47.1042 278.89 47.1042Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 273,
    y: 45,
    width: 7,
    height: 2.5,
    rx: 1.25,
    fill: "#00B0A6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 45,
    width: 7,
    height: 2.5,
    rx: 1.25,
    fill: "#00B0A6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 273,
    y: 60,
    width: 7,
    height: 2.5,
    rx: 1.25,
    fill: "#00B0A6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 60,
    width: 7,
    height: 2.5,
    rx: 1.25,
    fill: "#00B0A6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.499 193.574L247.191 206L360 206V173.5L312.5 146L227.499 193.574Z",
    fill: "#00B0A6",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4);
export default __webpack_public_path__ + "static/media/step_4.b05084a90a25224aedce1f89efe78310.svg";
export { ForwardRef as ReactComponent };